import { IconSvg } from '@wome/ui'
import React, { ReactNode, useRef } from 'react'
import { FormattedMessage } from 'react-intl'

import styles from './styles.module.scss'

import useOnClickOutside from '@/hooks/useOnClickOutside'

import { useAuth } from '@/providers/auth/useAuth'
import { useHouse } from '@/providers/useHouse'

export const ItemMenu = ({
  label,
  onClick,
  icon,
  closeMenu,
  styleLabel = {},
}: {
  label: ReactNode
  onClick: () => void
  icon: any
  closeMenu: () => void
  styleLabel?: React.CSSProperties
}) => {
  return (
    <div
      className={styles.item_menu}
      onClick={() => {
        onClick()
        closeMenu()
      }}
    >
      {icon}
      <span className={styles.label_menu} style={styleLabel}>
        {label}
      </span>
    </div>
  )
}

const HeaderMenu = ({ closeMenu }: { closeMenu: () => void }) => {
  const ref = useRef<HTMLDivElement>(null)
  const { runLogout } = useAuth()
  const { setHouse } = useHouse()
  // eslint-disable-next-line unused-imports/no-unused-vars
  useOnClickOutside(ref, (event: any) => {
    const path = event.path || (event.composedPath && event.composedPath())
    if (path && path.find((x: any) => x.id === 'menuUser')) {
      return
    }
    closeMenu()
  })

  return (
    <div className={styles.menu} ref={ref}>
      <ItemMenu
        onClick={() => {
          runLogout()
          setHouse(undefined)
        }}
        label={
          <FormattedMessage
            id='app.header.menu.user.logout'
            defaultMessage='Déconnexion'
          />
        }
        icon={<IconSvg.LogOut />}
        closeMenu={closeMenu}
      />
    </div>
  )
}

export default HeaderMenu
